export class MaskOptionsModel {
    constructor(data) {
        if (!data)
            return;
        this.Method = data.Effect;
        this.TrimMethod = data.TrimmingMethod;
        this.Selector = data.Selector;
        this.AllowedCharactersCount = data.AllowedCharactersCount || data.Characters || 0;
        this.CurrentCharacterCount = 0;
        this.Terminator = data.Terminator || "...";
        this.ContainerHeight = data.ContainerHeight || 0;
        this.TemplateType = data.TemplateType;
        this.ExcludeClasses = data.ExcludeClasses || ['Mg2-connext'];
        this.AllowedFadedCharactersCount = data.AllowedFadedCharactersCount || 0;
    }
}
